import logo_src from "./logo.png";
import Profile from "../lib/VRCore/pages/UserProfile/UserProfile";
import Profile_reducer from "../lib/VRCore/pages/UserProfile/reducer";
import { selectName } from "../lib/VRCore/pages/UserProfile/selectors";
import { getProfile } from "../lib/VRCore/pages/UserProfile/actions";

const staging =
    process.env.REACT_APP_PRODUCTION_BUILD === "YES" ? "" : " Staging";

const sentry_dsn =
    process.env.REACT_APP_PRODUCTION_BUILD === "YES"
        ? "https://d67d7b09fb8245caa2d9f7698a5035ff@sentry.io/1427735"
        : "https://b56e9f9fcf27408d98974f73df2998c0@sentry.io/1429025";

const profile = {
    title: `ProWork Dashboard${staging}`,
    component: {
        view: Profile,
        reducer: Profile_reducer,
        reducer_key: "UserProfile_reducer"
    },
    name_selector: selectName,
    get_profile_action: getProfile,
    logo_src,
    sentry_dsn,
    map_api_key: "AIzaSyCbOaitX3pdrf5FHAeP6hrnVfGl1NZX1rw"
};

export default profile;
